import {
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Box,
  Divider,
  Button,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import "../../PrimeiraConsulta/modulos/styles.css";
import "./styles.css";
import { ReactComponent as IconEdit } from "../../../images/iconEdit.svg";

const TextItem = ({ label, value }) => {
  return (
    <Stack>
      <Typography
        sx={{
          fontFamily: "Ninuto, sans-serif !important",
          fontSize: "16px",
          fontWeight: 600,
          lineHeight: "22px",
          letterSpacing: "0em",
          textAlign: "left",
          marginRight: "8px",
          color: "#333333 !important",
        }}
      >
        {label}
      </Typography>
      <Typography className="itemTextSubTitle">{value}</Typography>
    </Stack>
  );
};

export default function DadosClinicosPaciente({
  respostaByPerguntaId,
  idadeInicioDoenca,
  atrasoDiagnostico,
  cirurgias,
  tempoCirurgias,
  onEdit = () => {},
}) {
  return (
    <Accordion className="AccordionContainer">
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="DadosClinicosPaciente-content"
        id="DadosClinicosPaciente-header"
        className="AccordionSummaryContainer"
        position="relative"
      >
        <Typography className="Accordion_title">
          Dados Clínicos do paciente
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          className="templateGridForm"
          alignItems="self-start"
          position="relative"
        >
          {onEdit && (
            <Button
              onClick={onEdit}
              sx={{ position: "absolute", right: 30, zIndex: 100, top: -66 }}
            >
              <IconEdit />
            </Button>
          )}
          <TextItem
            label="Data do primeiro sintoma:"
            value={respostaByPerguntaId(6)}
          />
          <TextItem
            label="Data do diagnóstico:"
            value={respostaByPerguntaId(205) ?? "-"}
          />
          <TextItem
            label="Idade no início dos sintomas:"
            value={`${respostaByPerguntaId(7) || "-"} anos`}
          />
          <TextItem
            label="Idade no início da doença:"
            value={idadeInicioDoenca === 0 ? "-" : idadeInicioDoenca + " anos"}
          />

          <TextItem
            label="Fenótipo de início:"
            value={respostaByPerguntaId(211) ?? "-"}
          />

          <TextItem
            label="Atraso no diagnóstico:"
            value={
              atrasoDiagnostico !== "-" ? atrasoDiagnostico + " mes(es)" : "-"
            }
          />

          <TextItem
            label="Local do primeiro sintoma: "
            value={respostaByPerguntaId(5)}
          />
          <TextItem
            label="Tipo de ELA:"
            value={respostaByPerguntaId(209) ?? "-"}
          />

          <TextItem
            label="Estado de residência no início da doença:"
            value={respostaByPerguntaId(2)}
          />

          <TextItem
            label="Município de residência no início da doença:"
            value={respostaByPerguntaId(3)}
          />
          <TextItem
            label="Tempo de moradia nesse município:"
            value={respostaByPerguntaId(4)}
          />
          <TextItem
            label="Altura:"
            value={`${respostaByPerguntaId(8)?.replace(".", "") || "-"} cm`}
          />
          <TextItem
            label="Peso inicial:"
            value={`${respostaByPerguntaId(9) || "-"} kg`}
          />
          <TextItem label="IMC inicial:" value={respostaByPerguntaId(10)} />
        </Box>

        <Divider sx={{ mb: 2, mt: 2 }} />

        <Stack>
          <Typography className="dadosClinicosSubTitleSection">
            Anamnese
          </Typography>

          <Typography className="itemTextSubTitle colorBlueDark">
            {respostaByPerguntaId(1)}
          </Typography>
        </Stack>

        <Divider sx={{ mb: 2, mt: 2 }} />

        <Typography className="dadosClinicosSubTitleSection">
          Sinais e sintomas
        </Typography>
        <Box className="dadosClinicosContainerChip">
          {respostaByPerguntaId(11)?.map((nome, idx) => (
            <Chip className="dadosClinicosChip" label={nome} key={idx}></Chip>
          ))}
          {respostaByPerguntaId(12) &&
            respostaByPerguntaId(12)[0].length > 0 && (
              <Chip
                className="dadosClinicosChip"
                label={respostaByPerguntaId(12)}
              />
            )}
        </Box>

        <Divider sx={{ mb: 2, mt: 2 }} />

        <Typography className="dadosClinicosSubTitleSection">
          Antecedentes pessoais
        </Typography>
        <Box className="dadosClinicosContainerChip">
          {respostaByPerguntaId(13)?.map((nome, idx) => (
            <Chip className="dadosClinicosChip" label={nome} key={idx}></Chip>
          ))}
          {respostaByPerguntaId(14) &&
            respostaByPerguntaId(14)[0].length > 0 && (
              <Chip
                className="dadosClinicosChip"
                label={respostaByPerguntaId(14)}
              ></Chip>
            )}
        </Box>

        <Divider sx={{ mb: 2, mt: 2 }} />

        <Typography className="dadosClinicosSubTitleSection">
          Comorbidades
        </Typography>

        <Box className="dadosClinicosContainerChip" mt="8px">
          {respostaByPerguntaId(15)?.map((nome, idx) => (
            <Chip className="dadosClinicosChip" label={nome} key={idx}></Chip>
          ))}
        </Box>
        <Box className="dadosClinicosContainerChip" mt="8px">
          {respostaByPerguntaId(16)?.map((nome, idx) => (
            <Chip className="dadosClinicosChip" label={nome} key={idx}></Chip>
          ))}
        </Box>

        <Divider sx={{ mb: 2, mt: 2 }} />

        <Typography className="dadosClinicosSubTitleSection">
          Cirurgias
        </Typography>
        <Box className="dadosClinicosContainerChip">
          {cirurgias.map((nome, idx) => (
            <Chip className="dadosClinicosChip" label={nome} key={idx}></Chip>
          ))}
        </Box>

        <Typography
          className="dadosClinicosSubTitleSection colorBlueDark"
          sx={{ mb: 2, mt: 2 }}
        >
          Há quanto tempo
        </Typography>
        <Box className="dadosClinicosContainerChip">
          {tempoCirurgias.map((nome, idx) => (
            <Chip className="dadosClinicosChip" label={nome} key={idx}></Chip>
          ))}
        </Box>

        <Divider sx={{ mb: 2, mt: 2 }} />

        <Typography className="dadosClinicosSubTitleSection">
          Histórico familiar
        </Typography>
        <Box
          className="templateGridForm"
          gridTemplateColumns="repeat(auto-fit, minmax(280px, 1fr))"
        >
          <Stack>
            <Typography className="dadosClinicosSubTitleSection colorBlueDark">
              Histórico familiar de doença psiquiátrica
            </Typography>
            <Box className="dadosClinicosContainerChip">
              {!respostaByPerguntaId(203) &&
                !respostaByPerguntaId(25) &&
                respostaByPerguntaId(24) && (
                  <Chip
                    className="dadosClinicosChip"
                    label={respostaByPerguntaId(24)}
                  ></Chip>
                )}
              {respostaByPerguntaId(203) &&
                respostaByPerguntaId(203)?.map((nome, idx) => (
                  <Chip
                    className="dadosClinicosChip"
                    label={nome}
                    key={idx}
                  ></Chip>
                ))}
              {respostaByPerguntaId(25) &&
                respostaByPerguntaId(25)[0].length > 0 && (
                  <Chip
                    className="dadosClinicosChip"
                    label={respostaByPerguntaId(25)}
                  ></Chip>
                )}
            </Box>
          </Stack>
          <Stack>
            <Typography className="dadosClinicosSubTitleSection colorBlueDark">
              Histórico familiar de ELA
            </Typography>
            <Box className="dadosClinicosContainerChip">
              {!respostaByPerguntaId(201) &&
                !respostaByPerguntaId(21) &&
                respostaByPerguntaId(20) && (
                  <Chip
                    className="dadosClinicosChip"
                    label={respostaByPerguntaId(20)}
                  ></Chip>
                )}
              {respostaByPerguntaId(201) &&
                respostaByPerguntaId(201)?.map((nome, idx) => (
                  <Chip
                    className="dadosClinicosChip"
                    label={nome}
                    key={idx}
                  ></Chip>
                ))}
              {respostaByPerguntaId(21) &&
                respostaByPerguntaId(21)[0].length > 0 && (
                  <Chip
                    className="dadosClinicosChip"
                    label={respostaByPerguntaId(21)}
                  ></Chip>
                )}
            </Box>
          </Stack>
          <Stack>
            <Typography className="dadosClinicosSubTitleSection colorBlueDark">
              Histórico familiar de demência
            </Typography>
            <Box className="dadosClinicosContainerChip">
              {!respostaByPerguntaId(202) &&
                !respostaByPerguntaId(23) &&
                respostaByPerguntaId(22) && (
                  <Chip
                    className="dadosClinicosChip"
                    label={respostaByPerguntaId(22)}
                  ></Chip>
                )}
              {respostaByPerguntaId(202) &&
                respostaByPerguntaId(202)?.map((nome, idx) => (
                  <Chip
                    className="dadosClinicosChip"
                    label={nome}
                    key={idx}
                  ></Chip>
                ))}
              {respostaByPerguntaId(23) &&
                respostaByPerguntaId(23)[0].length > 0 && (
                  <Chip
                    className="dadosClinicosChip"
                    label={respostaByPerguntaId(23)}
                  ></Chip>
                )}
            </Box>
          </Stack>
        </Box>

        <Divider sx={{ mb: 2, mt: 2 }} />

        <Typography className="dadosClinicosSubTitleSection">
          Medicamentos do paciente
        </Typography>
        <Box
          className="templateGridForm"
          gridTemplateColumns="repeat(auto-fit, minmax(280px, 1fr))"
        >
          <Stack>
            <Typography className="dadosClinicosSubTitleSection colorBlueDark">
              Uso de riluzol
            </Typography>
            <Box className="dadosClinicosContainerChip">
              <Chip
                className="dadosClinicosChip"
                label={respostaByPerguntaId(26)}
              ></Chip>
            </Box>
          </Stack>
          {respostaByPerguntaId(27) && (
            <Stack>
              <Typography className="dadosClinicosSubTitleSection colorBlueDark">
                Data de início:
              </Typography>
              <Box>
                <Chip
                  className="dadosClinicosChip"
                  label={respostaByPerguntaId(27)}
                ></Chip>
              </Box>
            </Stack>
          )}
        </Box>

        {!respostaByPerguntaId(30) &&
          !respostaByPerguntaId(31) &&
          !respostaByPerguntaId(32) && (
            <>
              <Divider sx={{ mb: 2, mt: 2 }} />
              <Typography className="dadosClinicosSubTitleSection">
                Alergias ou reações adversas
              </Typography>
              <Box className="dadosClinicosContainerChip" mb={1}>
                <Chip
                  className="dadosClinicosChip"
                  label={"Não"}
                  key={"Alergias ou reações adversas"}
                />
              </Box>
            </>
          )}

        {(respostaByPerguntaId(30) ||
          respostaByPerguntaId(31) ||
          respostaByPerguntaId(32)) && (
          <>
            <Divider sx={{ mb: 2, mt: 2 }} />

            <Typography className="dadosClinicosSubTitleSection">
              Alergias ou reações adversas
            </Typography>
            <Box className="dadosClinicosContainerChip" mb={1}>
              <Chip
                className="dadosClinicosChip"
                label={"Sim"}
                key={"Alergias ou reações adversas"}
              />
            </Box>
            <Box
              className="templateGridForm"
              gridTemplateColumns="repeat(auto-fit, minmax(280px, 1fr))"
              alignItems="self-start"
            >
              {respostaByPerguntaId(30) && (
                <Stack>
                  <Typography className="dadosClinicosSubTitleSection colorBlueDark">
                    Alimentos:
                  </Typography>
                  <Box className="dadosClinicosContainerChip">
                    {respostaByPerguntaId(30)?.map((nome, idx) => (
                      <Chip
                        className="dadosClinicosChip"
                        label={nome}
                        key={idx}
                      ></Chip>
                    ))}
                  </Box>
                </Stack>
              )}
              {respostaByPerguntaId(31) && (
                <Stack>
                  <Typography className="dadosClinicosSubTitleSection colorBlueDark">
                    Medicamentos:
                  </Typography>
                  <Box className="dadosClinicosContainerChip">
                    {respostaByPerguntaId(31)?.map((nome, idx) => (
                      <Chip
                        className="dadosClinicosChip"
                        label={nome}
                        key={idx}
                      ></Chip>
                    ))}
                  </Box>
                </Stack>
              )}
              {respostaByPerguntaId(32) && (
                <Stack>
                  <Typography className="dadosClinicosSubTitleSection colorBlueDark">
                    Outros:
                  </Typography>
                  <Box className="dadosClinicosContainerChip">
                    {respostaByPerguntaId(32)?.map((nome, idx) => (
                      <Chip
                        className="dadosClinicosChip"
                        label={nome}
                        key={idx}
                      ></Chip>
                    ))}
                  </Box>
                </Stack>
              )}
            </Box>
          </>
        )}

        <Divider sx={{ mb: 2, mt: 2 }} />

        <Typography className="dadosClinicosSubTitleSection">
          Observações
        </Typography>
        <Typography className="itemTextSubTitle colorBlueDark">
          {respostaByPerguntaId(33)}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
}
